import TaskDescriptionViewModelT from '@/ViewModels/Controls/TaskDescriptionViewModel';
import { ComponentManager, ControlFactory, DataTransferObject } from "radpresentation.htmlclient.defaultviewextensions";

export default class TaskDescriptionFactory extends ControlFactory {
    public viewModel: any;
    public control: any;
    private TaskDescriptionViewModel: any;
    private TaskDescription: any;
    private jQueryControl: JQuery;

    constructor(params: any) {
        super(params);
        this.TaskDescriptionViewModel = ComponentManager.getViewModel<typeof TaskDescriptionViewModelT>('TaskDescriptionViewModel');
        this.TaskDescription = ComponentManager.getControl('TaskDescription');
    }

    public getControl(): any {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.viewModel = (() =>
            new this.TaskDescriptionViewModel({
                factory: this,
                isEnabled: this.isEnabled,
                isValid: this.isValid,
                context: this.context,
                WFEUserTaskCompleteInformationDTO: this.context.genericObject.getComputed(this.detailViewItem.name, {
                    read: observable => {
                        let dto = DataTransferObject.parseFromXML(observable());
                        return dto;
                    },
                    write: (observable, value) => {
                        let xml = DataTransferObject.toXMLString(value);
                        observable(xml);
                    }
                })
            }))();
        this.control = (() => new this.TaskDescription(this.viewModel))();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        return this.jQueryControl;
    }
}

ComponentManager.setFactory('TaskDescription', TaskDescriptionFactory, 'WorkflowEngineHTMLViewExtension');
ComponentManager.setFactory('WorkflowEngineViewExtension.UIComponents.TaskDescription', TaskDescriptionFactory, 'WorkflowEngineHTMLViewExtension');